const hideOnScroll = {
    init() {
        document.addEventListener('DOMContentLoaded', function () {

            const header = document.querySelector('.site-header');
            const scrollThreshold = 10;
            let lastScrollTop = 0;

            window.addEventListener('scroll', function () {

                const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

                if (Math.abs(scrollTop - lastScrollTop) <= scrollThreshold) {
                    return;
                }

                if (scrollTop > lastScrollTop && scrollTop > 100) {
                    // scrolling down
                    header.classList.add('header-hidden');
                } else {
                    // scrolling up
                    header.classList.remove('header-hidden');
                }

                lastScrollTop = scrollTop;

            });

        });
    }
};

export default hideOnScroll;
